interface FileOptions {
  encoding: string;
  contentType: string;
  fileName: string;
}

// well-known trick to force file download programmatically
// from https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
export const download = (content: string, options: FileOptions) => {
  const { encoding, contentType, fileName } = options;
  const element = document.createElement('a');

  element.setAttribute('href', `data:${contentType};${encoding}, ${content}`);
  element.setAttribute('download', fileName);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const downloadFile = (href: string) => {
  const a = document.createElement('a');
  a.href = href;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * Check if a file can be displayed directly in a browser
 * @param fileName - target file name
 */
export const canInlineFile = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  return extension && ['html', 'htm', 'txt', 'yaml', 'xml', 'json'].includes(extension);
};

export const formatBytes = (bytes: number, decimals = 0): string => {
  if (bytes === 0) return '0B';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
